
import React from "react";
import { Utils } from ".";
import { i18nManager } from "../i18n";
import { ITransaction } from "../services";

export interface ExpiryTimeKeeperProps {
    expiryDate: Date;
    reportExpiry: () => void;
}

function ExpiryTimeKeeper(props: ExpiryTimeKeeperProps) {
    const labels = i18nManager.Labels.compound;
    const [dateDifferences, setDateDifferences] = React.useState({ days: 0, hours: 0, seconds: 0, minutes: 0 });

    React.useEffect(() => {
        const dateCounterInterval = setInterval(() => {
            setDateDifferences(Utils.extractDateDifferences(props.expiryDate));
        }, 1000);
        return () => {
            clearInterval(dateCounterInterval);
        };
    }, []);

    React.useEffect(() => {
        if (dateDifferences.days < 0) {
            props.reportExpiry();
            return;
        }
    }, [dateDifferences]);

    return (<div className="time-countdown">
        <span className="expiry">{labels.details.txn_expire_in}</span>
        <span className="time">{dateDifferences.days}{i18nManager.Labels.time_keeping.d} : {dateDifferences.hours}{i18nManager.Labels.time_keeping.h} : {dateDifferences.minutes}{i18nManager.Labels.time_keeping.m} : {dateDifferences.seconds}{i18nManager.Labels.time_keeping.s}</span>
    </div>);
}

export default ExpiryTimeKeeper;
